import { ReactNode, useEffect, useState } from 'react';
import { StyledCopyAssistDropdown } from 'modules/ai/copyAssist/components/dropdown/styles';

interface CopyAssistDropdownProps {
  children?: ReactNode;
  /** ref for the element to target */
  targetRef?: React.RefObject<HTMLDivElement> | null;
}

export const CopyAssistDropdown = ({ children, targetRef }: CopyAssistDropdownProps) => {
  const [dropdownCssTop, setDropdownCssTop] = useState(0);

  useEffect(() => {
    const cssTop =
      targetRef && targetRef.current ? targetRef.current?.getBoundingClientRect().height : 0;
    setDropdownCssTop(cssTop);
  }, []);

  return (
    <StyledCopyAssistDropdown top={dropdownCssTop} data-test="copy-assist-dropdown">
      {children}
    </StyledCopyAssistDropdown>
  );
};
